// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/static/images/welcome_image.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-modal {
  position: fixed;
  display: table;
  top: -40px;
  height: calc(100% + 40px);
  width: 100%;
  z-index: 1002;
  opacity: 1;
  -webkit-transition: background-color linear 0.5s;
  transition: background-color linear 0.5s;
  background-color: #FFF;
}
.welcome-modal--transparent {
  background-color: rgba(0, 0, 0, 0.35) !important;
  -webkit-box-shadow: 1px 1px 6px 0 rgba(0, 0, 0, 0.49);
          box-shadow: 1px 1px 6px 0 rgba(0, 0, 0, 0.49);
}
.welcome-modal__wrap {
  width: 640px;
  height: 380px;
  top: 50%;
  left: 50%;
  margin-top: -200px;
  margin-left: -353px;
  background: #FFF;
  border-radius: 2px;
  position: absolute;
  text-align: center;
  padding: 32px;
}
.welcome-modal__image {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  width: 100%;
  height: 160px;
  margin-bottom: 40px;
}
.welcome-modal__header {
  display: block;
  margin-bottom: 16px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #002E33;
}
.welcome-modal__subtext {
  display: block;
  margin-bottom: 48px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #697588;
}
.welcome-modal__css-loader {
  margin: 0 auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 0.8em solid #00E383;
  border-right: 0.8em solid #00E383;
  border-bottom: 0.8em solid #00E383;
  border-left: 0.8em solid #002E33;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
  top: -9px;
}
.welcome-modal__css-loader, .welcome-modal__css-loader:after {
  border-radius: 50%;
  width: 5em;
  height: 5em;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.welcome-modal__start-invoicing {
  display: inline-block;
  height: 19px;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.19;
  letter-spacing: normal;
  text-align: left;
  color: #01FF94;
  border-radius: 12px;
  -webkit-box-shadow: 1px 1px 3px 0 #F5F6F9;
          box-shadow: 1px 1px 3px 0 #F5F6F9;
  background-color: #002E33;
  padding: 16px 64px;
  margin: auto;
  cursor: pointer;
}
.welcome-modal__start-invoicing:hover {
  color: #FFF;
  background-color: #075E42;
}

@media screen and (max-width: 750px) {
  .welcome-modal--transparent {
    background-color: #FFF !important;
  }
  .welcome-modal__header {
    padding: 0 164px;
  }
  .welcome-modal__subtext {
    padding: 0 164px;
  }
}
@media screen and (max-width: 700px) {
  .welcome-modal__header {
    font-size: 18px;
  }
  .welcome-modal__subtext {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/client/components/Modal/WelcomeModal/styles.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,gDAAA;EAAA,wCAAA;EACA,sBCHI;ADER;AAGI;EACI,gDAAA;EACA,qDAAA;UAAA,6CAAA;AADR;AAII;EACI,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBCjBA;EDkBA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AAFR;AAKI;EACI,oEAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAHR;AAMI;EACI,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC3CO;ADuCf;AAOI;EACI,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cCDC;ADJT;AASI;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;EACA,gCAAA;EACA,gCAAA;EAEA,wBAAA;EACA,6CAAA;EACA,qCAAA;EACA,SAAA;AAPR;AAUI;EAEI,kBAAA;EACA,UAAA;EACA,WAAA;AATR;AAYI;EACI;IACI,+BAAA;IACA,uBAAA;EAVV;EAYM;IACI,iCAAA;IACA,yBAAA;EAVV;AACF;AAaI;EACI;IACI,+BAAA;IACA,uBAAA;EAXV;EAaM;IACI,iCAAA;IACA,yBAAA;EAXV;AACF;AAcI;EACI,qBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cCjHQ;EDkHR,mBAAA;EACA,yCAAA;UAAA,iCAAA;EACA,yBCnHO;EDoHP,kBAAA;EACA,YAAA;EACA,eAAA;AAZR;AAcQ;EACI,WCnHJ;EDoHI,yBChGD;ADoFX;;AAiBA;EACI;IACI,iCAAA;EAdN;EAiBE;IACI,gBAAA;EAfN;EAkBE;IACI,gBAAA;EAhBN;AACF;AAmBE;EACE;IACI,eAAA;EAjBN;EAoBE;IACI,eAAA;EAlBN;AACF","sourcesContent":["@import '../../../Global/Colors.scss';\n\n.welcome-modal {\n    position: fixed;\n    display: table;\n    top: -40px;\n    height: calc(100% + 40px);\n    width: 100%;\n    z-index: 1002;\n    opacity: 1;\n    transition: background-color linear .5s;\n    background-color: $White;\n\n    &--transparent {\n        background-color: rgba($Black, 0.35) !important;\n        box-shadow: 1px 1px 6px 0 rgba($Black, 0.49);\n    }\n\n    &__wrap {\n        width: 640px;\n        height: 380px;\n        top: 50%;\n        left: 50%;\n        margin-top: -200px;\n        margin-left: -353px;\n        background: $White;\n        border-radius: 2px;\n        position: absolute;\n        text-align: center;\n        padding: 32px;\n    }\n\n    &__image {\n        background: url('/static/images/welcome_image.svg') no-repeat center;\n        width: 100%;\n        height: 160px;\n        margin-bottom: 40px;\n    }\n\n    &__header {\n        display: block;\n        margin-bottom: 16px;\n        text-align: center;\n        font-size: 24px;\n        font-weight: bold;\n        color: $DeepSeaGreen;\n    }\n\n    &__subtext {\n        display: block;\n        margin-bottom: 48px;\n        text-align: center;\n        font-size: 16px;\n        font-weight: 500;\n        color: $Gray90;\n\n    }\n\n    &__css-loader {\n        margin: 0 auto;\n        font-size: 10px;\n        position: relative;\n        text-indent: -9999em;\n        border-top: .8em solid $Green;\n        border-right: .8em solid $Green;\n        border-bottom: .8em solid $Green;\n        border-left: .8em solid $DeepSeaGreen;\n        -webkit-transform: translateZ(0);\n        -ms-transform: translateZ(0);\n        transform: translateZ(0);\n        -webkit-animation: load8 1.1s infinite linear;\n        animation: load8 1.1s infinite linear;\n        top: -9px;\n    }\n\n    &__css-loader,\n    &__css-loader:after {\n        border-radius: 50%;\n        width: 5em;\n        height: 5em;\n    }\n\n    @-webkit-keyframes load8 {\n        0% {\n            -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n        }\n        100% {\n            -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n    }\n\n    @keyframes load8 {\n        0% {\n            -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n        }\n        100% {\n            -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n    }\n\n    &__start-invoicing {\n        display: inline-block;\n        height: 19px;\n        font-size: 16px;\n        font-weight: bold;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.19;\n        letter-spacing: normal;\n        text-align: left;\n        color: $ElectricGreen;\n        border-radius: 12px;\n        box-shadow: 1px 1px 3px 0 $Gray20;\n        background-color: $DeepSeaGreen;\n        padding: 16px 64px;\n        margin: auto;\n        cursor: pointer;\n\n        &:hover {\n            color: $White;\n            background-color: $Green140;\n        }\n    }\n}\n\n@media screen and (max-width: 750px) {\n    .welcome-modal--transparent {\n        background-color: $White  !important;\n    }\n\n    .welcome-modal__header {\n        padding: 0 164px;\n    }\n\n    .welcome-modal__subtext {\n        padding: 0 164px;\n    }\n  }\n\n  @media screen and (max-width: 700px) {\n    .welcome-modal__header {\n        font-size: 18px;\n    }\n\n    .welcome-modal__subtext {\n        font-size: 12px;\n    }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
